<div class="row">
  <div class="col">



    <app-eca-select [options]="allTrainingTypeCategory" [(selectedId)]="trainingType.trainingTypeCategoryId"
                    [isRequired]="true"
                    label="Category"
                    [isReadOnly]="!editingType"
                    popoverText="Please select a category for this Course (Optional)">
    </app-eca-select>
      <app-eca-input label="Name" [isRequired]="true" [controlId]="'ctrlTrainingTypeName'"
                     [isReadOnly]="!editingType"
                     [(value)]="trainingType.name"
                     [isValid]="!saveAttempted || !!trainingType?.name"
                     validationMessage="Please enter the name for the training course/type"
                     popoverText="Please enter a short name for the training course/type to refer to it later">
      </app-eca-input>
  </div>
</div>
<div class="row">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
    <div class="container" style="padding-right: 0; padding-left: 0;">
      <app-eca-html-editor label="Description"
                           popoverText="Enter the details of the training type"
                           [(content)]="trainingType.description"
                           [isReadOnly]="!editingType"
                           [isRequired]="false"

                           validationMessage="Please enter the description for the training course/type">
      </app-eca-html-editor>
    </div>

  </div>
</div>
<div class="row">
  <div class="col">
    <app-eca-date-picker [isDisabled]="!editingType" [controlId]="'ctrlTypeHeldOn'"
                         label="Held On"
                         [(dateValue)]="trainingType.heldOn"
                         [isRequired]="false"
                         popoverText="Please enter the date that this training course was held on if applicable">
    </app-eca-date-picker>

  </div>

</div>
<div class="row">
  <div class="col">
    <app-eca-date-picker [isDisabled]="!editingType" [controlId]="'ctrlTypeValidTo'"
                         label="Valid To"
                         [(dateValue)]="trainingType.validTo"
                         [isRequired]="false"
                         popoverText="Please enter the date that this training course is valid to if applicable">
    </app-eca-date-picker>

  </div>
</div>
